const initialState = {
  invoices: [],
  customerInvoices: [],
  totalInvoices: 0,
  totalPages: 0,
  isLoading: false,
}

const invoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_INVOICE_LOADING":
      return {
        ...state,
        isLoading: action.data,
      }
    case `SET_INVOICES`:
      return {
        ...state,
        invoices: action.data,
      }

    case "UPDATE_INVOICE": {
      const updated = action.data
      const exists = state.invoices.some(inv => inv._id === updated._id)
      return {
        ...state,
        invoices: exists
          ? state.invoices.map(inv => (inv._id === updated._id ? updated : inv))
          : [updated, ...state.invoices],
      }
    }
    case `SET_CUSTOMER_INVOICES`:
      return {
        ...state,
        customerInvoices: action.data,
      }
    case `SET_TOTAL_INVOICES`:
      return {
        ...state,
        totalInvoices: action.data,
      }
    case `SET_TOTAL_PAGES`:
      return {
        ...state,
        totalPages: action.data,
      }
    default:
      return state
  }
}

export default invoicesReducer
